import { TableNumberWidget, BaseFieldWidget, ModelFieldType, SPI, ViewType, RowContext } from '@kunlun/dependencies';
import { VNode } from 'vue';
import { removeDecimalZero } from '../../../utils/number';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Table],
    ttype: [ModelFieldType.Float]
  })
)
export class RemoveZeroTableFloatWidget extends TableNumberWidget {
  renderDefaultSlot(context: RowContext): VNode[] | string {
    return removeDecimalZero(super.renderDefaultSlot(context));
  }
}
